import React from 'react';

// Result of a project shift (Planning/PROJECT-SHIFT-2026-08-21.md §9.1) -
// renders what the SERVER reports: body.moved, body.alreadyShifted and
// body.kickoff. Deliberately NO per-task list (Bill, 2026-08-21 - "a full
// list is unnecessary"); the Gantt itself shows the new dates, and failures
// never reach this modal - a partial write surfaces through the 409 path
// with its outcome. The response still carries body.tasks for that path.

const formatDateDisplay = (dateStr) => {
    if (!dateStr) return '-';
    const d = new Date(dateStr);
    return d.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

const ShiftSummaryModal = ({ isOpen, onClose, summary }) => {
    if (!isOpen || !summary) return null;

    const { deltaDays, moved, alreadyShifted, kickoff } = summary;
    const weeks = Math.abs(deltaDays / 7);
    const direction = deltaDays > 0 ? 'forward' : 'back';

    return (
        <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4 flex flex-col">
                {/* Header */}
                <div className="px-6 py-4 border-b border-gray-200">
                    <h2 className="text-lg font-semibold text-gray-900">
                        Project Shift Complete
                    </h2>
                    <p className="text-sm text-gray-600 mt-1">
                        Shifted {weeks} week{weeks !== 1 ? 's' : ''} {direction}
                    </p>
                </div>

                {/* The report: what worked, and anything an earlier attempt
                    already covered. */}
                <div className="px-6 py-4">
                    <div className="bg-gray-50 rounded-lg p-3 text-sm text-gray-600 space-y-1">
                        <div>
                            Rows moved: <span className="font-medium text-gray-900">{moved}</span>
                        </div>
                        {alreadyShifted > 0 && (
                            <div>
                                Already moved by an earlier attempt:{' '}
                                <span className="font-medium text-gray-900">{alreadyShifted}</span>
                            </div>
                        )}
                        {kickoff && (
                            <div>
                                Kick-off:{' '}
                                <span className="font-medium text-gray-900">
                                    {formatDateDisplay(kickoff.before)} → {formatDateDisplay(kickoff.after)}
                                </span>
                            </div>
                        )}
                    </div>
                </div>

                {/* Footer */}
                <div className="px-6 py-4 border-t border-gray-200 flex justify-end">
                    <button
                        onClick={onClose}
                        className="bg-primary-600 hover:bg-primary-700 text-white px-4 py-2 rounded-md text-sm font-medium"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ShiftSummaryModal;
